/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { StickySeverity } from "./StickySeverity";
import {
  StickySeverityFromJSON,
  StickySeverityFromJSONTyped,
  StickySeverityToJSON,
  StickySeverityToJSONTyped,
} from "./StickySeverity";
import type { StickyEntityType } from "./StickyEntityType";
import {
  StickyEntityTypeFromJSON,
  StickyEntityTypeFromJSONTyped,
  StickyEntityTypeToJSON,
  StickyEntityTypeToJSONTyped,
} from "./StickyEntityType";
import type { StickyCategory } from "./StickyCategory";
import {
  StickyCategoryFromJSON,
  StickyCategoryFromJSONTyped,
  StickyCategoryToJSON,
  StickyCategoryToJSONTyped,
} from "./StickyCategory";

/**
 *
 * @export
 * @interface StickyHistory
 */
export interface StickyHistory {
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  historyId?: string;
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  stickyId?: string;
  /**
   *
   * @type {StickyEntityType}
   * @memberof StickyHistory
   */
  entityType?: StickyEntityType;
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  action?: string;
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  description?: string;
  /**
   *
   * @type {StickyCategory}
   * @memberof StickyHistory
   */
  category?: StickyCategory;
  /**
   *
   * @type {string}
   * @memberof StickyHistory
   */
  editedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof StickyHistory
   */
  editedAt?: OffsetDateTime;
  /**
   *
   * @type {StickySeverity}
   * @memberof StickyHistory
   */
  severity?: StickySeverity;
}

/**
 * Check if a given object implements the StickyHistory interface.
 */
export function instanceOfStickyHistory(value: object): value is StickyHistory {
  return true;
}

export function StickyHistoryFromJSON(json: any): StickyHistory {
  return StickyHistoryFromJSONTyped(json, false);
}

export function StickyHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StickyHistory {
  if (json == null) {
    return json;
  }
  return {
    historyId: json["historyId"] == null ? undefined : json["historyId"],
    stickyId: json["stickyId"] == null ? undefined : json["stickyId"],
    entityType:
      json["entityType"] == null
        ? undefined
        : StickyEntityTypeFromJSON(json["entityType"]),
    entityId: json["entityId"] == null ? undefined : json["entityId"],
    action: json["action"] == null ? undefined : json["action"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    category:
      json["category"] == null
        ? undefined
        : StickyCategoryFromJSON(json["category"]),
    editedBy: json["editedBy"] == null ? undefined : json["editedBy"],
    editedAt: json["editedAt"] == null ? undefined : json["editedAt"],
    severity:
      json["severity"] == null
        ? undefined
        : StickySeverityFromJSON(json["severity"]),
  };
}

export function StickyHistoryToJSON(json: any): StickyHistory {
  return StickyHistoryToJSONTyped(json, false);
}

export function StickyHistoryToJSONTyped(
  value?: StickyHistory | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    historyId: value["historyId"],
    stickyId: value["stickyId"],
    entityType: StickyEntityTypeToJSON(value["entityType"]),
    entityId: value["entityId"],
    action: value["action"],
    title: value["title"],
    description: value["description"],
    category: StickyCategoryToJSON(value["category"]),
    editedBy: value["editedBy"],
    editedAt: value["editedAt"],
    severity: StickySeverityToJSON(value["severity"]),
  };
}
